import { type Context, createContext } from 'react';

import type {
  BaseFeatureFlags,
  LaunchDarklyContext,
  LaunchDarklyCustomer,
} from '../launch-darkly.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createLaunchDarklyProviderContext<
  FeatureFlags extends BaseFeatureFlags,
>() {
  return createContext<
    LaunchDarklyProviderContextType<FeatureFlags> | undefined
  >(undefined);
}

// ─── Types ───────────────────────────────────────────────────────────────────

export type LaunchDarklyProviderContextType<
  FeatureFlags extends BaseFeatureFlags,
> = {
  isLaunchDarklyReady: boolean;
  isLaunchDarklyTargetingContextSet: boolean;
  defaultFlags: FeatureFlags;
  flagOverrides: Partial<FeatureFlags>;
  addContext: (
    contextKind: string,
    context: LaunchDarklyContext,
  ) => Promise<void>;
  addContexts: (contexts: Record<string, LaunchDarklyContext>) => Promise<void>;
  identifyCustomer: (
    customer: LaunchDarklyCustomer,
    extraContext?: LaunchDarklyContext,
  ) => Promise<void>;
  resetCustomer: (extraContext?: LaunchDarklyContext) => Promise<void>;
  overrideFeatureFlag: (key: keyof FeatureFlags, value: unknown) => void;
  clearFeatureFlagOverrides: () => void;
};

export type LaunchDarklyProviderContext<FeatureFlags extends BaseFeatureFlags> =
  Context<LaunchDarklyProviderContextType<FeatureFlags> | undefined>;
